// extracted by mini-css-extract-plugin
export default {"banner":"hC2IfJ"};